
export interface InjectedAd {
    _type: 'ad'
    id: string,
    uuid: string,
}
export function injectAd<TContent>(
    items: TContent[],
    adEvery: number,
    adOffset: number = 0,
): (InjectedAd|TContent)[] {
    const withInjected = [ ];

    for (const item of items) {
        if (withInjected.length % adEvery === adOffset) {
            withInjected.push( { _type: 'ad', id: Math.random().toString(36).substring(7), uuid: Math.random().toString(36).substring(7) } );
        }
        withInjected.push(item);
    }

    // Special case for the last item being an ad
    if (withInjected.length % adEvery === adOffset + 1) {
        withInjected.push( { _type: 'ad', id: Math.random().toString(36).substring(7), uuid: Math.random().toString(36).substring(7) } );
    }

    return withInjected;
}
